<template>
  <div v-if="items && items.length">
    <div tile elevation="0" class="results-holder">
      <v-card tile>
        <v-skeleton-loader class="mx-auto" type="table-row-divider@6" v-if="$store.state.loader"></v-skeleton-loader>
        <v-data-table v-else dense :loading="loading"
          :headers="tableHeaders" :items="items" :items-per-page="itemsPerPage" disable-sort hide-default-footer
          @dblclick:row="openIresaLink" class="elevation-1">
          <template v-slot:top>
            <div class="d-flex justify-end">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-2 mt-2" elevation="0" v-bind="attrs" small v-on="on">
                    <span v-if="sort && sort.title">{{ sort.title }}</span>
                    <span v-else>Trier</span>

                    <v-icon right dark> mdi-chevron-down </v-icon>
                  </v-btn>
                </template>
                <v-list flat dense>
                  <v-list-item link dense v-for="(item, index) in sortItems" :key="index" @click="setSorting(item)">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:header.sellNotes="{ header }">
            <div ref="sellNotesHeader" class="flex items-center">
              <span id="sellNotesHeader">{{ header.text }}</span>
            </div>
          </template>

          <template v-slot:item.age="{ item }">
            {{ item.age_min }} <span v-if="item.age_max">-</span>
            {{ item.age_max }}
          </template>

          <template v-slot:item.url="{ item }">
            <a v-if="item.url" :href="`https://${ucpaDomain}${item.url}`" target="_blank">Voir</a>
          </template>
          <template v-slot:item.min_depart_guarantee="{ item }">     
            <MinDepartGuarantee
              :item="item"
              :tempMinPaxGuarantee="tempMinPaxGuarantee"
              :loading="loading"
              @toggle-loading="toggleLoading()"
              @update-new-min-depart-guarantee="updateNewMinDepartGuarantee(item)"
            ></MinDepartGuarantee>
          </template>

          <!-- LABALAGUERE WRITE VALUES VALUES -->
          <template v-slot:item.minPax="{ item }">     
            <MinDepartGuarantee
              :item="item"
              :tempMinPaxGuarantee="tempMinPaxGuarantee"
              min-pax-key="minPax"
              :loading="loading"
              @toggle-loading="toggleLoading()"
              @update-new-min-depart-guarantee="updateNewMinDepartGuarantee(item)"
            ></MinDepartGuarantee>
          </template>
          <template v-slot:item.sellNotes="{ item, index }">
            <SellNotes
            style="position:relative"
              :id="`sellNotesButton-${index}`"
              :sell-notes="item.sellNotes"
              :updated-item="dialogContent"
              @start-editing-dialog="(action) => openSellNotesPopup('sellNotes', item, action, index, 'Note vendeurs')"
              @set-items-new-value="setItemsNewValue(dialogContent.date, dialogContent.field, dialogContent.value, dialogContent.packageCode)"
              @toggle-loading="toggleLoading()"
              @reset-dialog="resetDialog()"
            ></SellNotes>
            <SellNotesDialog v-click-outside="closeSellNotesPopup" v-if="showSellNotesPopup && sellNoteIndex === index" style :style="popupStyle" :dialog-content="dialogContent" @close="closeSellNotesPopup()" @save="dialogContent.action"/>
          </template>
          <template v-slot:item.webNotes="{ item, index }"> 
            <WebNotes
              :web-notes="item.webNotes"
              :updated-item="dialogContent"
              @start-editing-dialog="(action) => startEditingDialog('webNotes', item, action, index, 'Note Web')"
              @set-items-new-value="setItemsNewValue(dialogContent.date, dialogContent.field, dialogContent.value)"
              @toggle-loading="toggleLoading()"
              @reset-dialog="resetDialog()"
            ></WebNotes>
          </template>
          <template v-slot:item.sellStatus="{ header, item }"> 
            <SellStatus
              :status-options="statusOption"
              :item="item"
              :isDisabled="header.isDisabled"
              @set-items-new-value="(departDate, key, value, iresaCode) => setItemsNewValue(departDate, key, value, iresaCode)"
              @toggle-loading="toggleLoading()"
            ></SellStatus>
          </template>
    
          <template v-slot:item.guidStopVent="{ header, item }"> 
            <IresaStopSale
              :item="item"
              :options="header.customOptions"
              @set-items-new-value="(departDate, key, value, iresaCode) => setItemsNewValue(departDate, key, value, iresaCode)"
              @toggle-loading="toggleLoading()"
            ></IresaStopSale>
          </template>          
    
          <template v-slot:item.guides="{ item }"> 
            <Guides
             @start-editing-dialog="openGuideDialog(item)"
              :guides="item.guides"
            ></Guides>
          </template>

          
          <template v-slot:item.date="{ item }">
            <span> {{ formatDate(item.date) }}</span>
            <div v-if="item.transport_type && item.available_stock === 0 && item.vendable && $store.state.activeBrand === 'ucpa'">{{ getRequestLabel(item) }}</div>
          </template>
          <template v-slot:item.dateDepart="{ item }">
            <span> {{ formatDate(item.dateDepart) }}</span>
          </template>
          <template v-slot:item.dateRetourn="{ item }">
            <span> {{ formatDate(item.dateRetourn) }}</span>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-card tile>
      <v-row class="no-gutters mx-0">
        <v-col cols="12" class="pa-0"><v-divider /></v-col>
        <v-col cols="2" class="pa-0 d-flex align-center">
          <span class="caption ml-6">Nombre de résultats : {{ total }}</span>
        </v-col>
        <v-col class="d-flex justify-center align-center py-2" cols="8">

          <v-btn :disabled="page === 1 ? true : false" @click="setPage(page - 1)" small class="mx-1" color="white">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>

          <v-btn small class="mx-1" text disabled>
            <span class="black--text">{{ page }}</span>
          </v-btn>

          <v-btn :disabled="pageCount === page ? true : false" small class="mx-1" color="white"
            @click="setPage(page + 1)">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" class="d-flex justify-end align-center pa-0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2 caption result-list" elevation="0" v-bind="attrs" small v-on="on">{{ itemsPerPage }}
                <v-icon right dark> mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <v-list flat dense>
              <v-list-item dense v-for="(item, index) in perPageItems" :key="index" @click="setItemsPerPage(item)">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="auto">
        <v-dialog
          persistent
          v-model="dialog"
          transition="dialog-top-transition"
          max-width="600"
        >
          <EditDialog
            v-if="dialog"
            :dialogContent="dialogContent"
            @close="resetDialog()"
            @save="dialogContent.action"
          />
        </v-dialog>
      </v-col>

      <!-- GUIDE DIALOG -->
    <v-col cols="auto">
      <v-dialog
        persistent
        v-model="guideDialog"
        transition="dialog-top-transition"
        max-width="600"
      >
        <template>
          <v-card>
            <v-toolbar
              color="primary"
              dark
            > Accompagnateur </v-toolbar>
            <v-card-text class="pt-4" v-if="guideDialogContent">
              <div v-for="index of 2" :key="index" class="d-flex align-center">
                {{ index }}
              <v-text-field 
                :value="guideDialogContent.guides && guideDialogContent.guides[index -1] ? guideDialogContent.guides[index -1].fullName : ''"
                readonly
                class="pa-1" label="Accompagnateur" dense filled hide-details single-line >
              </v-text-field>
              <v-btn
                @click="actionGuide(guideDialogContent, index-1)"
                icon
              >
                <v-icon> {{guideDialogContent.guides && guideDialogContent.guides[index -1] ? 'mdi-minus' : 'mdi-plus'}}  </v-icon>
            </v-btn>
              
            </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="guideDialog = false"
              >Fermer</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>

  </v-row>
  </div>
  <div style="height: 25vh;" class="d-flex justify-center align-center caption grey--text" v-else>
    <div class="text-center">
      <img class="image" src="../../public/img/robots.png" />
      <span class="d-block mt-4">aucun résultat trouvé ...</span>
    </div>
  </div>
</template>

<script>
// working way
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);
dayjs.extend(utc)


import { globalMixin } from '../mixins';

import { getDataTableHeadersConfiguration } from '../configs/helper'

// VUE_APP_API_SPEEDBOAT_URL
const { VUE_APP_IRESA_URL, VUE_APP_UCPA_DOMAIN, VUE_APP_COLLAB_URL } = process.env;

import WebNotes from "./results/WebNotes.vue";
import SellNotes from "./results/SellNotes.vue";
import SellStatus from "./results/SellStatus.vue";
import IresaStopSale from "./results/IresaStopSale.vue";
import Guides from "./results/Guides.vue";
import MinDepartGuarantee from "./results/MinDepartGuarantee.vue";
import EditDialog from "./modals/EditDialog.vue";
import SellNotesDialog from "./modals/SellNotesDialog.vue";

export default {
  mixins: [globalMixin],
  components: { WebNotes, SellNotes, SellStatus, IresaStopSale, MinDepartGuarantee, Guides, EditDialog, SellNotesDialog },
  props: {
    hits: {
      type: Array,
      default: () => []
    },
    total: Number,
    page: Number,
    itemsPerPage: Number,
    sort: Object,
    tableHeight: {
      type: Number,
      default: 225
    }
  },
  data() {
    return {
      dialog: false,
      guideDialog: false,
      guideDialogContent: null,
      dialogContent: {
        field: null,
        value: null, 
        dialogLabel: null,
        action: null,
        valueIndex: null
      },
      statusOption: [
        "Non renseigné",
        "Confirmé",
        "Annulé"
      ],
      ucpaDomain: VUE_APP_UCPA_DOMAIN,
      iresaUrl: VUE_APP_IRESA_URL,
      loading: false,
      sortItems: [
        { title: "Pertinence" },
        { title: "Prix croissant", value: { price: "asc" } },
        { title: "Prix décroissant", value: { price: "desc" } }
      ],
      perPageItems: [5, 10, 15, 20, 50],
      items: [],
      tempMinPaxGuarantee: {},
      showSellNotesPopup: false,
      sellNoteIndex: null,
      popupStyle: {
        position: 'fixed',
        top: '0',
        left: '0',
        'z-index': 9999
      }
    };
  },
  computed: {
    tableHeaders() {
      return getDataTableHeadersConfiguration()
    },  
    pageCount() {
      let pages = Math.floor(this.total / this.itemsPerPage);

      if (pages >= 1000) { // Need to check if can get pagination for more than 10.000 hits
        pages = 1000;
      } else if (this.total / this.itemsPerPage - pages !== 0) {
        // Add one more page if difference of the division is not 0
        pages += 1;
      }

      return pages;
    },
  },
  methods: {
    openGuideDialog(item) {
        this.guideDialogContent = item
        this.guideDialog = true

    },
    async actionGuide(data, index) {
      if(data.guides && data.guides[index]) {
        this.items.find(item => item.dateDepart === data.dateDepart && item.iresaCode === data.iresaCode)
        this.items.forEach(item => {
          if(item.dateDepart === data.dateDepart && item.iresaCode === data.iresaCode) {
            item.guides.splice(index, 1)
          }
          return item
        })

        await this.$store.dispatch('setGuide', {date: data.dateDepart, iresaCode: data.iresaCode, guides:data.guides, removeAction: true})
      } else {
        let domain = window.location.hostname.includes('localhost') ? 'http://localhost:9020' : `https://${window.location.hostname}`
          const redirectUrl = `${VUE_APP_COLLAB_URL}/?redirect_url=${domain}&marque=${this.$store.state.contextInfo.rese_id}&request=call_center&date=${data.dateDepart}&iresaCode=${data.iresaCode}`
          this.$store.commit('setGuides', data.guides)

          window.location.href = redirectUrl
      }

      this.guideDialog = false
    },
    startEditingDialog(field, item, action, index, label) {
      this.dialog = true
      this.dialogContent.dialogLabel = label
      this.dialogContent.field = field
      this.dialogContent.date = item.dateDepart ?? item.date
      this.dialogContent.packageCode = item.iresaCode ?? item.id_package
      this.dialogContent.valueIndex = index
      this.dialogContent.value = item[field] ?  item[field] : null
      this.dialogContent.action = action
      this.dialogContent.partenaire = item.partner
      this.dialogContent.marque = item.marque
    
    },
    resetDialog() {
      this.dialogContent = {
        field: null,
        value: null,
        date: null,
        packageCode: null,
        action: null,
        valuIndex: null,
        dialogLabel: null
      };
      this.dialog = false;
      this.showSellNotesPopup = false;
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    setItemsNewValue (date, field, value, iresaCode) {
      this.items.map(item => {
        if((item.dateDepart === date || item.date === date) && (iresaCode === item.iresaCode || iresaCode === item.id_package)) {
          item[field] = value
        }
        return item
      })
    },
    setPage(val) {
      this.$emit("update:page", val);
    },
    setItemsPerPage(item) {
      this.$emit("update:itemsPerPage", item);
    },
    formatDate(date) {
      return dayjs.utc(date).format("DD-MM-YYYY");
    },
    getRequestLabel(item) {
      if (this.$store.state.activeBrand !== 'ucpa') return "";
      if (!item.vendable || item.available_stock > 0) return "";
      return item.transport_type === 'Avion' ? '(Request Aérien)' : '(Request terrestre)';
    },
    setSorting(val) {
      this.$emit("update:sort", val ? val : null)
    },
    openIresaLink(event, item) {
      item = item.item
      const contextInfo = this.$store.state.contextInfo;
     
     let startDate = 0
     let endDate  = 0
     switch(this.$store.state.activeBrand){
      case "labalaguere": 
       startDate = item.dateDepart ? dayjs.utc(item.dateDepart, 'x').format('YYYY-MM-DD') : 0;
       endDate = item.dateDepart ? dayjs.utc(item.dateDepart, 'x').add(item.duration, 'days').format('YYYY-MM-DD') : 0;
      break;

      case "ucpa":
       startDate = item.date ? dayjs.utc(item.date, 'x').format('YYYY-MM-DD') : 0;
       endDate = item.date ? dayjs.utc(item.date, 'x').add(item.duration, 'days').format('YYYY-MM-DD') : 0;
      break;
     }
   

      let participantsNumber = this.$store.state.filters.find(filter => filter.field === "available_stock");
      participantsNumber = participantsNumber && participantsNumber.value ? participantsNumber.value : 1;

      let iresaURL = this.iresaUrl;
      iresaURL += `?context_action=${contextInfo.context_action}`;
      iresaURL += `&context_id=${this.getItemCode(item)}`;
      iresaURL += `&context_debut=${startDate}`;
      iresaURL += `&context_fin=${endDate}`;
      iresaURL += `&fata_id=${contextInfo.fata_id}`;
      iresaURL += `&nb_pax=${participantsNumber}`;
      iresaURL += `&rese_id=${contextInfo.rese_id}`;

      window.open(iresaURL, '_self')
    },
    updateNewMinDepartGuarantee(item) {
      if (item[this.getMinPaxKey()] < 0) {
        return;
      }

      if (!this.tempMinPaxGuarantee[this.getItemCode(item)]) {
        this.tempMinPaxGuarantee[this.getItemCode(item)] = {};
      }

      // change to date because it doesn't matter the hours
      // const date = fromUnixTime(item.date / 1000);
      const dateString = dayjs.utc(this.getItemDate(item)).format('DD-MM-YYYY');

      this.tempMinPaxGuarantee[this.getItemCode(item)][dateString] = item[this.getMinPaxKey()];
      this.items = this.items.map((hit) => {
        // const tempDate = fromUnixTime(hit.date / 1000);
        const tempDateString = dayjs.utc(this.getItemDate(hit)).format('DD-MM-YYYY');

        if (
          this.tempMinPaxGuarantee[this.getItemCode(hit)] &&
          (this.tempMinPaxGuarantee[this.getItemCode(hit)][tempDateString] ||
            this.tempMinPaxGuarantee[this.getItemCode(hit)][tempDateString] === '')
        ) {
          hit[this.getMinPaxKey()] = this.tempMinPaxGuarantee[this.getItemCode(hit)][tempDateString];
        }
        return hit;
      });
    },
    getMinPaxKey() {
      const minPaxKeys = {
        'ucpa': 'min_pax_number_for_warranted_departure',
        'labalaguere': 'minPax'
      };

      return this.$store.state.activeBrand in minPaxKeys ? minPaxKeys[this.$store.state.activeBrand] : null;
    },
    closeSellNotesPopup() {
      this.showSellNotesPopup = false;
    },
    openSellNotesPopup(field, item, action, index, label) {
      if(this.showSellNotesPopup) return 
      const el = document.getElementById(`sellNotesButton-${index}`)
      if (!el) return;

      this.dialogContent.dialogLabel = label
      this.dialogContent.field = field
      this.dialogContent.date = item.dateDepart ?? item.date
      this.dialogContent.packageCode = item.iresaCode ?? item.id_package
      this.dialogContent.valueIndex = index
      this.dialogContent.value = item[field] ?  item[field] : null
      this.dialogContent.action = action
      this.dialogContent.partenaire = item.partner
      this.dialogContent.marque = item.marque
      
      const rect = el.getBoundingClientRect();
      this.popupStyle = {
        position: 'fixed',
        bottom: `${window.innerHeight - rect.bottom}px`,
        left: `${rect.right}px`,
        'z-index': 9999,
      };
      
      this.showSellNotesPopup = true;
      this.sellNoteIndex = index
    }
  },
  watch: {
    hits: function () {
      this.items = JSON.parse(JSON.stringify(this.hits));

      this.tempMinPaxGuarantee = {};
    }
  }
};
</script>
<style lang="scss">
.result-list {
  span {
    text-transform: none;
  }
}

.image {
  opacity: 0.4;
  width: 50%;
  height: 50%;
  margin-top: 5rem;
  margin-right: 3rem;
}

.results-holder {
  width: 100%;
  max-height: calc(100vh - 205px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.sell-notes-popup {
  position: fixed;
  display: flex;
  background: white;
  box-shadow: 0 3px 5px rgba(0,0,0,0.2);
  border-radius: 4px;
  padding: 12px;
}
</style>